import React, { useState } from "react";
import { Drawer } from "antd5";
import { ArrowLeftOutlined, CheckOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { ButtonItem } from "../../../../Components/Items";
import HiloMensajesSoporte from "./HiloMensajesSoporte";
import useAltoVisible from "./useAltoVisible";
import { SOPORTE_TEMA } from "./fasesSoporte";

const BOTON_BARRA = { width: 34, height: 34, borderRadius: "50%", padding: 0 };

/**
 * Conversación de un ticket a pantalla completa en celular: barra sobria con el
 * título, el hilo de mensajes ocupando el resto, y un panel que sube desde abajo
 * con el detalle del reporte.
 */
const ConversacionMovil = ({
    titulo,
    meta,
    onVolver,
    mensajes,
    loadingMensajes,
    enviando,
    onEnviar,
    perspectivaAgente,
    soloLectura,
    textoSoloLectura,
    usuarioId,
    etiquetaAccion,
    resaltarAccion,
    panelTitulo,
    panelContenido,
}) => {
    const [panelVisible, setPanelVisible] = useState(false);
    const { alto, top } = useAltoVisible();

    return (
        <div
            style={{
                position: "fixed",
                top,
                left: 0,
                right: 0,
                height: alto,
                zIndex: 1000,
                backgroundColor: SOPORTE_TEMA.surface,
                display: "flex",
                flexDirection: "column",
            }}
        >
            <div
                style={{
                    flexShrink: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 10,
                    padding: "8px 12px",
                    backgroundColor: SOPORTE_TEMA.surface,
                    borderBottom: `1px solid ${SOPORTE_TEMA.border}`,
                }}
            >
                <ButtonItem blanco lessTime icon={<ArrowLeftOutlined />} onClick={onVolver} style={BOTON_BARRA} />
                <div style={{ flex: 1, minWidth: 0 }}>
                    <div
                        style={{
                            fontWeight: 600,
                            fontSize: 15,
                            color: SOPORTE_TEMA.textPrimary,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                        }}
                    >
                        {titulo}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 2, minWidth: 0 }}>
                        {meta}
                    </div>
                </div>
                {resaltarAccion ? (
                    <ButtonItem naranjaB lessTime icon={<CheckOutlined />} onClick={() => setPanelVisible(true)}>
                        {etiquetaAccion}
                    </ButtonItem>
                ) : (
                    <ButtonItem blanco lessTime icon={<InfoCircleOutlined />} onClick={() => setPanelVisible(true)}>
                        {etiquetaAccion}
                    </ButtonItem>
                )}
            </div>

            <HiloMensajesSoporte
                mensajes={mensajes}
                loading={loadingMensajes}
                enviando={enviando}
                onEnviar={onEnviar}
                perspectivaAgente={perspectivaAgente}
                usuarioId={usuarioId}
                soloLectura={soloLectura}
                textoSoloLectura={textoSoloLectura}
            />

            <Drawer
                placement="bottom"
                height="88%"
                open={panelVisible}
                onClose={() => setPanelVisible(false)}
                title={panelTitulo}
                styles={{ body: { padding: "12px 16px" } }}
            >
                {panelContenido?.(() => setPanelVisible(false))}
            </Drawer>
        </div>
    );
};

export default ConversacionMovil;
